import React from "react";
import FCTable from "../FCTable";
const RewardItemTable = ({ rewards }) => {
  const tableData = (rewards || []).map((reward) => ({
    ...reward,
    name: reward?.itemName || "-",
    image:
      reward?.rewardItemsList &&
      Array.isArray(reward.rewardItemsList) &&
      reward.rewardItemsList.length > 0
        ? reward.rewardItemsList[0]?.files
        : "-",
    type: reward?.itemType || "-",
    points: reward?.itemPointValue || "-",
    reedemUrl: reward?.itemRedeemURL || "-",
  }));

  const productsColumns = [
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: false,
      center: false,
      wrap: true,
      minWidth: "20%",
      maxWidth: "20%",
      cell: (row) => (
        <div style={{ width: "100%" }}>
          <p style={{ textAlign: "left", margin: "0" }}>{row?.name}</p>
        </div>
      ),
    },
    {
      name: "Type",
      selector: (row) => row?.type,
      sortable: false,
      center: true,
      minWidth: "30%",
      maxWidth: "30%",
      cell: (row) => (
        <div style={{ width: "" }}>
          <p
            style={{
              margin: "0",
              textAlign: "center",
              backgroundColor: "#e3717178",
              color: "#fff",
              padding: "5px 10px",
              borderRadius: "5px",
              width: "auto",
            }}
          >
            {row?.type}
          </p>
        </div>
      ),
    },
    {
      name: "Points",
      selector: (row) => row?.points,
      sortable: false,
      center: true,
      minWidth: "20%",
      maxWidth: "20%",
    },
    {
      name: "Reedem URL",
      selector: (row) => row?.reedemUrl,
      sortable: false,
      center: true,
      minWidth: "30%",
      maxWidth: "30%",
      cell: (row) => (
        <div style={{ width: "100%", padding: "5px 0" }}>
          <p style={{ textAlign: "left", margin: "0" }}>{row?.reedemUrl}</p>
        </div>
      ),
    },
  ];
  return (
    <>
      <FCTable
        tableColumns={productsColumns}
        tableData={tableData}
        highlightOnHover
        onRowClicked={(row) => {}}
      />
    </>
  );
};

export default RewardItemTable;
